import { useEffect } from "react";
import Modal from "../../../components/ui/Modal";
import { useForm } from "react-hook-form";
import FieldError from "../../../components/ui/FieldError";
import RequiredField from "../../../components/ui/RequiredField";
import axiosConfig from "../../../services/Axios";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import { pickBy } from "lodash";

function SubCategorieForm({
  modalSubCategorieFormIsOpen,
  setModalSubCategorieFormIsOpen,
  categorie,
  setCategorie,
  subCategorie,
  setSubCategorie,
  getCategorie,
}) {
  const form = useForm();
  const { t } = useTranslation();

  const onSubmitSubCategorie = async (data) => {
    data.itemCategory = categorie["@id"];
    if (subCategorie) {
      try {
        await axiosConfig
          .patch(process.env.REACT_APP_API_URL + subCategorie["@id"], data, {
            headers: { "Content-Type": "application/merge-patch+json" },
          })
          .then((response) => {
            if (response?.status === 200 && response?.data) {
              setSubCategorie(response.data);
              let categorieClone = { ...categorie };
              categorieClone.itemSubCategories =
                categorieClone.itemSubCategories
                  .filter((sc) => sc.id !== response.data.id)
                  .concat(response.data);
              setCategorie(categorieClone);
              toast.success(t("global.changes_saved"), {
                theme: "colored",
                hideProgressBar: true,
              });
              setModalSubCategorieFormIsOpen(false);
              getCategorie(categorie.id);
            }
          });
      } catch (e) {
        if (e.response.status !== 200 && e.response.data?.violations) {
          e.response.data.violations.map((v) => {
            form.setError(v.propertyPath, {
              type: "manual",
              message: v.message,
            });
          });
        }
      }
    } else {
      try {
        const sanitizedData = pickBy(
          data,
          (value) =>
            value !== null &&
            (value > 0 ||
              value.length > 0 ||
              (typeof value === "object" && !Array.isArray(value)))
        );
        await axiosConfig
          .post(
            process.env.REACT_APP_API_URL + "/api/item_sub_categories",
            sanitizedData
          )
          .then((response) => {
            if (response?.status === 201 && response?.data) {
              setSubCategorie(response.data);
              let categorieClone = { ...categorie };
              categorieClone.itemSubCategories =
                categorieClone.itemSubCategories.concat(response.data);
              setCategorie(categorieClone);
              getCategorie(categorie.id);
              toast.success(t("categories.sub-categories.created"), {
                theme: "colored",
                hideProgressBar: true,
              });
              setModalSubCategorieFormIsOpen(false);
            }
          });
      } catch (e) {
        if (e.response.status !== 200 && e.response.data?.violations) {
          e.response.data.violations.map((v) => {
            form.setError(v.propertyPath, {
              type: "manual",
              message: v.message,
            });
          });
        }
      }
    }
  };

  useEffect(() => {
    form.reset();
  }, [modalSubCategorieFormIsOpen]);

  return (
    <div>
      {modalSubCategorieFormIsOpen && (
        <Modal
          showModal={modalSubCategorieFormIsOpen}
          setShowModal={setModalSubCategorieFormIsOpen}
          title={
            subCategorie
              ? t("categories.sub-categories.edit")
              : t("categories.sub-categories.create")
          }
          sendLabel={t("global.btn.save")}
          onSubmit={form.handleSubmit(onSubmitSubCategorie)}
        >
          <form onSubmit={form.handleSubmit(onSubmitSubCategorie)}>
            <div className="grid grid-cols-12 gap-3">
              <div className="col-span-12">
                <label>
                  {t("categories.sub-categories.name")}
                  <RequiredField /> :
                </label>
                <input
                  {...form.register("name")}
                  name="name"
                  type="text"
                  className="w-full"
                  defaultValue={subCategorie?.name}
                  aria-invalid={form.formState?.errors?.name ? true : false}
                />
                <FieldError error={form.formState?.errors?.name} />
              </div>
            </div>
          </form>
        </Modal>
      )}
    </div>
  );
}

export default SubCategorieForm;
